import React from 'react';
import './Footer.css';
import { Mail, Phone, MessageCircle, Facebook, Instagram, Linkedin, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <>
      <div className="footer-divider">
        <img src={require('../../assets/images/footer-bg.jpg')} alt="Footer Divider" className="divider-image" />
      </div>
      <footer className="footer">
        <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Aqua Broadcast</h3>
            <p>
              نحن شركة رائدة في مجال معدات البث الإذاعي والتلفزيوني، نقدم حلولاً متطورة 
              وخدمات عالية الجودة لعملائنا في جميع أنحاء العالم.
            </p>
            <p>
              <strong>العنوان:</strong> بيروت، لبنان - شارع الحمرا
            </p>
          </div>
          
          <div className="footer-section">
            <h3>المنتجات</h3>
            <a href="#products">مرسلات FM</a>
            <a href="#products">معالجات الصوت</a>
            <a href="#products">مضخمات FM</a>
            <a href="#products">أجهزة الاستقبال</a>
            <a href="#products">مصادر الطاقة</a>
            <a href="#products">قطع الغيار</a>
          </div>
          
          <div className="footer-section">
            <h3>الخدمات</h3>
            <a href="#services">الدعم الفني</a>
            <a href="#services">التدريب التقني</a>
            <a href="#services">الصيانة الدورية</a>
            <a href="#services">الاستشارات الفنية</a>
            <a href="#services">التنزيلات</a>
            <a href="#services">الأسئلة الشائعة</a>
          </div>
          
          <div className="footer-section">
            <h3>اتصل بنا</h3>
            <div className="contact-item">
              <Mail size={16} className="contact-icon" />
              <div className="contact-text">
                <p>info@aquabroadcast.me</p>
              </div>
            </div>
            <div className="contact-item">
              <Phone size={16} className="contact-icon" />
              <div className="contact-text">
                <p className="phone-number">+961 79 334 256</p>
              </div>
            </div>
            <div className="contact-item">
              <MessageCircle size={16} className="contact-icon" />
              <div className="contact-text">
                <p>واتساب: <span className="phone-number">+961 79 334 256</span></p>
              </div>
            </div>
            <div className="social-links" style={{ marginTop: '1rem' }}>
              <a href="https://www.facebook.com/aquabroadcast" target="_blank" rel="noopener noreferrer" className="social-link">
                <Facebook size={20} />
              </a>
              <a href="https://www.instagram.com/aquabroadcast" target="_blank" rel="noopener noreferrer" className="social-link">
                <Instagram size={20} />
              </a>
              <a href="https://www.linkedin.com/company/aquabroadcast" target="_blank" rel="noopener noreferrer" className="social-link">
                <Linkedin size={20} />
              </a>
              <a href="https://www.youtube.com/c/aquabroadcast" target="_blank" rel="noopener noreferrer" className="social-link">
                <Youtube size={20} />
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>
            &copy; 2024 Aqua Broadcast. جميع الحقوق محفوظة. | 
            <a href="#" style={{ marginRight: '1rem', marginLeft: '1rem' }}>سياسة الخصوصية</a> | 
            <a href="#" style={{ marginRight: '1rem' }}>شروط الاستخدام</a>
          </p>
        </div>
      </div>
    </footer>
    </>
  );
};

export default Footer;
